import { toast } from 'react-toastify';
import { approvePayout, disApprovePayout } from '../../../api/superAdmin';

export const approvePayoutData = async (type, id, setLoading, refresh) => {
    try {
        setLoading(true);
        const res = await approvePayout(type, id);
        if (res.status === 200) {
            setLoading(false);
            toast.success('Payment approved sucessfully');
            refresh();
        }
    } catch (error) {
        setLoading(false);
    }
};

export const disApprovePayoutData = async (type, id, setLoading, refresh) => {
    try {
        setLoading(true);
        const res = await disApprovePayout(type, id);
        if (res.status === 200) {
            setLoading(false);
            toast.success('Payment disapproved sucessfully');
            refresh();
        }
    } catch (error) {
        setLoading(false);
    }
};
